import { render, staticRenderFns } from "./UserPartnerContent.vue?vue&type=template&id=5f8951c5"
import script from "./UserPartnerContent.vue?vue&type=script&lang=ts"
export * from "./UserPartnerContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports